import FilterSessionStorageKeys from 'shared/constants/filterSessionStorageKeys';

export const clearAllActiveFilters = (): void => {
  for (const value of Object.values(FilterSessionStorageKeys)) {
    sessionStorage.removeItem(value);
  }
};
